import { Outlet } from 'react-router-dom'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

import { useCurrentUser } from './hooks/auth'
import SideNav from './components/SideNav'
import TopNav from './components/TopNav'
import PageFooter from './components/PageFooter'

export default function Layout({
  children, returnToOnLogin = false, ...props
}) {
  const { currentUser } = useCurrentUser()
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        '--top-nav-height': '70px',
        '--side-nav-width': { xs: '150px', md: '200px' },
        margin: '0',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'justify-content',
      }}
    >
      <TopNav {...{currentUser, returnToOnLogin}}/>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: 'var(--top-nav-height)',
        minHeight: 'calc(100vh - var(--top-nav-height))',
      }}>
        { currentUser ? <SideNav {...{ currentUser }}/> : null }
        <Box sx={{
          flex: `1 1 calc(100vw - var(--side-nav-width))`,
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Box {...props} sx={{
            flexGrow: 1,
            // minHeight: '100vh',
            ...props.sx
          }}>
            {children || <Outlet/>}
          </Box>
          <PageFooter/>
        </Box>
      </Box>
    </Container>
  )
}
